// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + (chunkId === 8135 ? "heatensim" : chunkId) + "." + {"3630":"4b058fd6","7873":"24565726","8135":"670c104e"}[chunkId] + ".chunk.css";
};